var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({class:_vm.classes,attrs:{"disabled":_vm.disabled}},_vm.$listeners.click ? { click: _vm.$listeners.click } : {}),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }